import { createContext, ReactNode, useState } from 'react';
import { api } from '../server/api';
import { IPlayerKPI } from '../interfaces/IPlayerKPI';

interface KPIContextProps {
  playerKPI: IPlayerKPI;
  getPlayerKPI: (playerId: string) => void;
}

interface KPIContextProviderProps {
  children: ReactNode;
}

export const KPIContext = createContext({} as KPIContextProps);

export function KPIContextProvider(props: KPIContextProviderProps) {
  const [playerKPI, setPlayerKPI] = useState<IPlayerKPI>();

  const getPlayerKPI = async (playerId: string) => {
    try {
      const response = await api.get(`/kpi/player/${playerId}`);
      if (response.data.error) {
        throw new Error();
      }

      setPlayerKPI(response.data.body);
    } catch (error) {
      console.log('getPointsProcessing error: ', error);
    }
  };

  return (
    <KPIContext.Provider
      value={{
        playerKPI,
        getPlayerKPI,
      }}
    >
      {props.children}
    </KPIContext.Provider>
  );
}
